/**
 * Expose all endponts for 'account'.
 */
const AccountApi = (api) => ({
  get: () => api.get('account'),
})

export default AccountApi



// WEBPACK FOOTER //
// ./src/services/api/AccountApi.js